import * as fieldTypes from "./fieldTypes";

export default {
  [fieldTypes.STATUS]: null,
};
